import axios from "axios";

export const submitDemoRequestToSharePoint = ({
  companyName,
  position,
  email,
  phoneNumber,
  service,
  description,
  channel,
}) => {
  const flowUrl = process.env.REACT_APP_DEMO_FLOW_URL;
  if (!flowUrl) {
    return Promise.reject(new Error("REACT_APP_DEMO_FLOW_URL is not configured"));
  }

  return axios.post(
    flowUrl,
    {
      companyName,
      position,
      email,
      phoneNumber,
      service,
      description,
      channel,
      submittedAt: new Date().toISOString(),
    },
    { headers: { "Content-Type": "application/json" } }
  );
};
